export enum WidgetMetricConfigurationOptions {
	STACKED_GROUPING = 'STACKED_GROUPING',
	SERIES_GROUPING = 'SERIES_GROUPING',
	PEER_HIERARCHY_GROUPING = 'PEER_HIERARCHY_GROUPING',
	TREND_ARROW = 'TREND_ARROW',
	PREVIOUS_PERIOD = 'PREVIOUS_PERIOD',
	MAP_WIDGET_GROUPING = 'MAP_WIDGET_GROUPING'
}
